import { render, staticRenderFns } from "./buyer-transaction.vue?vue&type=template&id=400219ad&"
import script from "./buyer-transaction.vue?vue&type=script&lang=js&"
export * from "./buyer-transaction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports